import React from 'react'

export default function navbar() {
  return (
    <header className='navbar'>
        <img src="./images/Fill 213.png" alt="earth" className='nav-img'/>
        <p className='nav-para'>my travel journal.</p>
    </header>
  )
}
